/* eslint-disable import/no-anonymous-default-export */
export const DRUPAL_URL = process.env.REACT_APP_DRUPAL_URL;
export const LAMBDA_ARTEH_API_DOMAIN =
	process.env.REACT_APP_LAMBDA_ARTEH_API_DOMAIN;
const LAMBDA_ARTEH_API_DOMAIN_TEST =
	process.env.REACT_APP_LAMBDA_ARTEH_API_DOMAIN_TEST;
const ENTITY_API_DOMAIN =
	process.env.REACT_APP_ENTITY_API_DOMAIN || LAMBDA_ARTEH_API_DOMAIN;
const S3_SAMPLES_URL = process.env.REACT_APP_S3_SAMPLES_URL;

// Export API domains for environment switching
export const API_DOMAINS = {
	prod: LAMBDA_ARTEH_API_DOMAIN,
	test: LAMBDA_ARTEH_API_DOMAIN_TEST,
};

export default {
	Dev: {
		Auth: "", // desativado
	},
	URL: {
		Drupal_Auth: {
			Login: DRUPAL_URL + "/",
			Logout: DRUPAL_URL + "/user/logout",
			Token: DRUPAL_URL + "/session/token",
		},
		Drupal_API: {
			AreaRestrita: {
				User: {
					Info: DRUPAL_URL + "/api/user",
					UpdatePassword: DRUPAL_URL + "/api/user/update_password",
					UpdateAvatar: DRUPAL_URL + "/api/user/update_avatar",
					UpdateData: DRUPAL_URL + "/api/user/update_data",
				},
				AWS: {
					S3importPresigned:
						LAMBDA_ARTEH_API_DOMAIN + "/api/aws/s3/import",
					sqsReportGenerateNotification:
						LAMBDA_ARTEH_API_DOMAIN + "/api/aws/sqs/report",
				},
				DashBoard: {
					index: DRUPAL_URL + "/api/dashboard",
				},
				FileUpload: {
					viewLog: LAMBDA_ARTEH_API_DOMAIN + "/api/log/file/import",
				},
				ReportUpload: {
					viewLog: LAMBDA_ARTEH_API_DOMAIN + "/api/log/file/report",
				},
				LogGeneric: {
					logS3UrlPreSigned:
						LAMBDA_ARTEH_API_DOMAIN + "/api/log/import/gets3url",
				},
				ArtehApi: {
					getToken: DRUPAL_URL + "/api/arteh/token",
				},
			},
		},
		ArtehAPI: {
			Dashboard: LAMBDA_ARTEH_API_DOMAIN + "/api/cpaDashboard",
			CompanySettings: LAMBDA_ARTEH_API_DOMAIN + "/api/company-settings",
			// Facility now goes through arteh-web-api so tier-based caps
			// (e.g. Starter is limited to 3 facilities) are enforced server-side.
			Facility: LAMBDA_ARTEH_API_DOMAIN + "/api/facility",
			Profit: ENTITY_API_DOMAIN + "/entity/profit",
			Equipment: ENTITY_API_DOMAIN + "/entity/equipment",
			Commuting: ENTITY_API_DOMAIN + "/entity/commuting",
			Country: ENTITY_API_DOMAIN + "/entity/country",
			State: ENTITY_API_DOMAIN + "/entity/state",
			BusinessTravels: ENTITY_API_DOMAIN + "/entity/business-travel",
			CodesUnlocodeOnlyPort:
				ENTITY_API_DOMAIN + "/entity/unlocode?isPort=1",
			FuelCombusted: ENTITY_API_DOMAIN + "/entity/fuel-combusted",
			FugitiveProcesses: ENTITY_API_DOMAIN + "/entity/fugitive-processes",
			FugitiveGases: ENTITY_API_DOMAIN + "/entity/fugitive-gases",
			ProcessesCalcination:
				ENTITY_API_DOMAIN + "/entity/processes-calcination",
			VehicleEmission: ENTITY_API_DOMAIN + "/entity/vehicle-emission",
			Vehicle: ENTITY_API_DOMAIN + "/entity/vehicle",
			Electricity: ENTITY_API_DOMAIN + "/entity/electricity",
			OtherEmission: ENTITY_API_DOMAIN + "/entity/other-emissions",
			TransportRoad: ENTITY_API_DOMAIN + "/entity/transport-road",
			TransportSea: ENTITY_API_DOMAIN + "/entity/transport-sea",
			FactorFuelsTransportNgaf:
				ENTITY_API_DOMAIN + "/entity/factors-fuels-transport-ngaf",
			TransportRoadVehicles:
				ENTITY_API_DOMAIN + "/entity/transport-road-vehicles",
			FactorFuelsNgaf: ENTITY_API_DOMAIN + "/entity/factors-fuels-ngaf",
			ProcessesFugitiveNgaf:
				ENTITY_API_DOMAIN + "/entity/processes-fugitive-ngaf",
			FactorsFugitiveNgaf:
				ENTITY_API_DOMAIN + "/entity/factors-fugitive-ngaf",
			FactorsProcessesNgaf:
				ENTITY_API_DOMAIN +
				"/entity/factors-processes-ngaf?onlyCalcination=1",
			TravelModeOnlyCommuting:
				ENTITY_API_DOMAIN + "/entity/travel-mode?onlyCommuting=1",
			GhgCategories: ENTITY_API_DOMAIN + "/entity/ghg-categories",
			Gvg: ENTITY_API_DOMAIN + "/entity/gvg",
			TransportSeaShips:
				ENTITY_API_DOMAIN + "/entity/transport-sea-ships",
			DecarbonizationStrategies:
				ENTITY_API_DOMAIN + "/entity/decarbonization-strategy",
			AppCategories: ENTITY_API_DOMAIN + "/entity/app-category",
			// Simulation routes go through arteh-web-api so the Starter
			// "no simulations" gate is enforced server-side.
			MACCSimulation: LAMBDA_ARTEH_API_DOMAIN + "/api/macc-simulation",
			Simulate: LAMBDA_ARTEH_API_DOMAIN + "/api/simulate",
			BillExtraction: {
				GetUploadUrl:
					LAMBDA_ARTEH_API_DOMAIN + "/api/bill-extraction/upload-url",
				List: LAMBDA_ARTEH_API_DOMAIN + "/api/bill-extraction/list",
				// Authenticated; web-api checks the fileKey's company prefix.
				Results: LAMBDA_ARTEH_API_DOMAIN + "/api/bill-extraction/results",
			},
		},
	},

	Storage: {
		Key: {
			ArtehAPI: "arteh-api-token",
			AcessToken: "access_token",
			LostToken: "warning_lost_session",
			isDark: "isDark",
		},
	},

	SampleFiles: {
		ImportTemplate: S3_SAMPLES_URL + "/sample-import-template.xlsm",
	},
};
